import { adminRoleIds } from "@/config/menuConfig";

/**
 * 从登录 token（JWT）中解析角色 Id
 * 后端 JwtHelper.CreateToken 会把 JsId 写入载荷，无需额外接口
 */
export const getRoleIdFromToken = () => {
  try {
    const raw = localStorage.getItem("token");
    const token = raw ? JSON.parse(raw)?.token : null;
    if (!token) return null;
    const part = token.split(".")[1];
    if (!part) return null;
    let base64 = part.replace(/-/g, "+").replace(/_/g, "/");
    // 补齐 base64 的 = 占位，避免 atob 抛异常
    base64 += "=".repeat((4 - (base64.length % 4)) % 4);
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    const payload = JSON.parse(json);
    const roleId = payload.JsId ?? payload.jsid ?? payload.JSID;
    return roleId != null ? Number(roleId) : null;
  } catch (e) {
    return null;
  }
};

/**
 * 是否超级管理员
 * 1. 后端 GetUser 返回的 IsAdmin（JsId == ConsValue:RoleId，默认 1）
 * 2. 角色 Id 在 menuConfig.adminRoleIds 白名单内（如「超管」角色）
 */
export const isSuperAdmin = (user) => {
  if (!user) return false;
  if (user.IsAdmin) return true;
  const roleId = user.JsId != null ? Number(user.JsId) : getRoleIdFromToken();
  return roleId != null && adminRoleIds.includes(roleId);
};
